export const OFFER_INFO_DESCRIPTION_GENERATED_CONTENT = {
    AGENCY_SALES_PREFIX: "sprzedaż prowadzi",
    CENTER: "centrum",
    DEVELOPER_BY: "przez",
    DEVELOPER_COMPLETED: "została zrealizowana",
    DEVELOPER_IN_PROGRESS: "jest realizowana",
    DISTANCE_KM_FROM: "km od",
    INVESTMENT_PREFIX: "Inwestycja",
    LOCATION_VERB: "znajduje się"
} as const;
export const OFFER_INFO_DESCRIPTION_GENERATED_CONTENT = {
    AGENCY_SALES_PREFIX: "sprzedaż prowadzi",
    CENTER: "centrum",
    DEVELOPER_BY: "przez",
    DEVELOPER_COMPLETED: "została zrealizowana",
    DEVELOPER_IN_PROGRESS: "jest realizowana",
    DISTANCE_KM_FROM: "km od",
    INVESTMENT_PREFIX: "Inwestycja",
    LOCATION_VERB: "znajduje się"
} as const;
